var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.421 0.43918C12.1398 0.157973 11.7583 0 11.3605 0C10.9628 0 10.5813 0.157973 10.3001 0.43918L6.42106 4.31818L2.54206 0.43918C2.25916 0.165943 1.88026 0.0147513 1.48696 0.0181689C1.09367 0.0215866 0.717451 0.17934 0.439339 0.457452C0.161227 0.735564 0.00347433 1.11178 5.67039e-05 1.50508C-0.00336092 1.89837 0.14783 2.27728 0.421067 2.56018L4.30006 6.43918L0.421067 10.3182C0.14783 10.6011 -0.00336092 10.98 5.67039e-05 11.3733C0.00347433 11.7666 0.161227 12.1428 0.439339 12.4209C0.717451 12.699 1.09367 12.8568 1.48696 12.8602C1.88026 12.8636 2.25916 12.7124 2.54206 12.4392L6.42106 8.56018L10.3001 12.4392C10.583 12.7124 10.9619 12.8636 11.3552 12.8602C11.7484 12.8568 12.1247 12.699 12.4028 12.4209C12.6809 12.1428 12.8386 11.7666 12.8421 11.3733C12.8455 10.98 12.6943 10.6011 12.421 10.3182L8.54205 6.43918L12.421 2.56018C12.7023 2.27889 12.8602 1.89743 12.8602 1.49968C12.8602 1.10193 12.7023 0.720471 12.421 0.43918Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f9649237a77cae34f4d721c3f695f873.svg";
export { ForwardRef as ReactComponent };